import axios from 'axios';
import Vue from 'vue'
import router from '../router'
import { locales } from '../../node_modules/moment';

var timer = false;

const downloadUrl = url => {
  let iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = url
  iframe.onload = function () {
    document.body.removeChild(iframe)
  }
  document.body.appendChild(iframe)
}
const baseUrl = "/api";
axios.interceptors.request.use((config) => {
  config.url= baseUrl+config.url;
  let Token = localStorage.getItem('Token');
  config.headers['authorization'] = `Bearer ${Token}`;
  return config;
})

axios.interceptors.response.use(
  res => {
    return res;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 提示(防抖)
          let vm = new Vue();
          if (timer) {
            clearTimeout(timer); 
          }

          timer = setTimeout( () => {
            vm.$message({
              message: '您的会话已过期，请重新登录',
              type: 'warning'
            });
          }, 500);

          // 清除token
          localStorage.removeItem('Token');

          // 跳转登录页
          router.replace('/');
      }
    }
    return Promise.reject(error.response.data)
  });
export default axios;



// WEBPACK FOOTER //
// ./src/config/axios.config.js